interface isElementInViewportPayload {
  element: HTMLElement;
  container: HTMLElement | null;
  skipHorizontalCheck?: boolean;
  offset?: number;
  containerOffset?: number;
}

const SCROLL_OFFSET = 16;

export const isElementInViewport = ({
  element,
  container,
  offset = 0,
  containerOffset = 0,
  skipHorizontalCheck,
}: isElementInViewportPayload): boolean => {
  const rect = element.getBoundingClientRect();

  if (container) {
    const containerRect = container.getBoundingClientRect();
    const offsetTop = containerRect.top;

    // floor needed for scaled viewport
    const isFitsHorizontally =
      skipHorizontalCheck ||
      (rect.left - containerRect.left >= 0 && Math.floor(rect.right - rect.left) <= container.offsetWidth);

    return (
      rect.top - containerRect.top >= 0 &&
      rect.bottom - containerOffset - offsetTop <= container.offsetHeight &&
      isFitsHorizontally
    );
  }

  return (
    rect.top >= 0 &&
    rect.left >= 0 &&
    rect.bottom - offset <= (window.innerHeight || document.documentElement.clientHeight) &&
    rect.right <= (window.innerWidth || document.documentElement.clientWidth)
  );
};

export const scrollToPage = (el: HTMLElement, page: number): void => {
  const pageToScroll = el.querySelector(`[data-page="${page}"]`) as HTMLElement | undefined;
  if (pageToScroll) {
    window.scrollTo({
      left: 0,
      top: pageToScroll.offsetTop - SCROLL_OFFSET,
    });
  }
};

export const getCurrentPage = (
  el: HTMLElement,
  container: HTMLElement | null,
  offset: number = 0,
): string | undefined => {
  const pages = Array.from(el.querySelectorAll('[data-page]')).reverse() as Array<HTMLElement>;
  const firstVisible = pages.find(page => isElementInViewport({ element: page, container, offset }));
  return firstVisible ? firstVisible.dataset.page : undefined;
};

export const scrollIntoView = (el: HTMLElement, slug: string, offset: number = 0): void => {
  const element = el.querySelector(`[data-post-slug='${slug}']`) as HTMLElement;
  if (element) {
    const currentPosition = element.getBoundingClientRect().top;

    window.scrollTo({
      left: 0,
      top: currentPosition - offset + SCROLL_OFFSET,
    });
  }
};

export const getElementByPostSlug = (el: HTMLElement, slug: string): HTMLElement | null => {
  return el.querySelector(`[data-post-slug='${slug}']`) as HTMLElement;
};
